import { KnaufMosaicColor } from './knauf-mosaic-color';
import { KnaufMosaicSet } from './knauf-mosaic-set';
import { Palettes } from './knauf-palette-sets';
import { KnaufPaletteSets } from './knauf-palette-sets';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KnaufPaletteSetService {

  constructor() { }

  getKnaufPaletteSets(): KnaufPaletteSets {
    return Palettes;
  }

  getKnaufMosaicSet(): KnaufMosaicColor[] {
    return KnaufMosaicSet;
  }
}
